import { timelineActionTypes } from './Timeline.actionTypes';

const initialState = {
  loading: false,
  loadingMore: false,
  error: null,
  sessionsByDay: [],
  page: 1,
  pageSize: 7,
  totalDays: 0,
  filters: {
    memberId: '',
    employeeId: '',
    startDate: '',
    endDate: '',
    timeZone: '',
  },
};

export default function timelineReducer(state = initialState, action) {
  switch (action.type) {
    case timelineActionTypes.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
